import React, { Fragment } from 'react';
import videojs from 'video.js';
require("video.js/dist/video-js.css");

export default class VideoJsPlayer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false
        };
    }
    componentDidMount() {
        let params = new URLSearchParams(window.location.search);
        let videoURL = params.get('url');
        let autoplay = params.get('autoplay') ? params.get('autoplay') : "1";
        autoplay = autoplay !== "1";
        let muted = params.get('muted') ? params.get('muted') : "1";
        muted = muted === "1" ? true : false;
        let controls = params.get('controls') ? params.get('controls') : "1";
        controls = controls === "1" ? true : false;
        let fluid = params.get('fluid') ? params.get('fluid') : "1";
        fluid = fluid === "1" ? true : false;
        let videoTitle = decodeURIComponent(params.get('title'));

        // console.log(videoURL, videoTitle, autoplay);
        this.setState({
            videoTitle, videoURL, isLoaded: true,
        })
        let videoJsOptions = {
            autoplay,
            muted,
            controls,
            fluid,
            sources: [{
                src: videoURL,
                type: "application/x-mpegURL"
            }]
        }
        // console.log("videoJsOptions",videoJsOptions);
        var player = videojs(this.videoNode, videoJsOptions, function onPlayerReady() {
            videojs.log('Video player is ready!');
            // this.play();
            this.on('ended', function () {
                videojs.log('Play again?!');
            });
        });

    }
    componentWillUnmount() {
        if (this.player) {
            this.player.dispose()
        }
    }

    render() {
        const { isLoaded, videoTitle, videoURL } = this.state;
        const headingStyle = {
            fontWeight: '700',
            fontSize: '18px',
            lineHeight: '20px'
        }
        return (
            <Fragment>
                <div data-vjs-player>
                    <video ref={node => this.videoNode = node} className="video-js"></video>
                </div>
                {/* <h1 style={headingStyle}>{videoTitle}</h1> */}
            </Fragment >
        )
    }
}